import { render } from "./GiftList.vue?vue&type=template&id=0876f87e"
import script from "./GiftList.vue?vue&type=script&lang=js"
export * from "./GiftList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__